import React, { useState, useContext } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { AuthContext } from '../../context/AuthContext';
import api from '../../api/client';

const { Title } = Typography;

const ChangePassword = () => {
  const { manager, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (!manager?.Hotel_Id) {
        message.error('Manager ID not found. Please login again.');
        return;
      }

      const response = await api.post(
        `manager_change_password/${manager.Hotel_Id}`,
        {
          oldPassword: values.currentPassword,
          password: values.newPassword,
          confirmPassword: values.confirmPassword,
          // backward-compatible keys (safe to send extra fields)
          currentPassword: values.currentPassword,
          newPassword: values.newPassword
        }
      );

      if (response.data.success || response.data.status) {
        message.success('Password changed successfully');
        form.resetFields();
      } else {
        message.error(response.data.message || 'Failed to change password');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else if (error.response?.status === 400) {
        message.error('Current password is incorrect');
      } else {
        message.error('Error changing password');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px', background: '#f5f5f5', minHeight: 'calc(100vh - 64px)' }}>
      <Card bordered={false} style={{ maxWidth: 600, margin: '0 auto', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
        <Title level={4} style={{ marginBottom: 24 }}>Change Password</Title>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Current Password"
            name="currentPassword"
            rules={[{ required: true, message: 'Please input your current password!' }]}
          >
            <Input.Password size="large" placeholder="Enter your current password" />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: 'Please input your new password!' },
              { min: 6, message: 'Minimum 6 characters.' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('currentPassword') !== value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('New password must be different from current password!'));
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder="Enter your new password" />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Confirm password does not match!'));
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder="Confirm your new password" />
          </Form.Item>

          <Form.Item style={{ marginTop: 32, marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" size="large" loading={loading} style={{ width: '100%', borderRadius: 8, height: 48, fontWeight: 600 }}>
              Update Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;
